module.exports = __webpack_public_path__ + "assets/img/scan.323d8d3d.svg";